import upload from 'common/service/upload';
import userSetting from 'common/service/userSetting';
import biddingTasks from 'common/service/biddingTasks';
import taskVersionServer from 'common/service/taskVersionServer';
import project from 'common/service/project';

import tasks from './tasks';
import message from './message';
import setting from './setting';
import comments from './comments';
import fosServer from './fosServer';
import taskQueue from './taskQueue';
import tianGong from './tianGongServer';
import modelLibrary from './modelLibrary';
import taskInstance from './taskInstance';
import exportVersions from './exportVersions';
import artTransaction from './artTransaction';
import taskTempSetting from './taskTempSetting';
import dynamicCheckItemSetting from './dynamicCheckItemSetting';
import evaluate from './evaluate';
import addVersion from './addVersion';
import dccCheck from './dccCheck';
import ugc from './ugc';

import activity from './activity';
import system from './system';

const service = {
  // common
  upload,
  userSetting,
  biddingTasks,
  taskVersionServer,

  // tiangong
  project,
  tasks,
  setting,
  message,
  comments,
  tianGong,
  fosServer,
  taskQueue,
  taskInstance,
  modelLibrary,
  exportVersions,
  artTransaction,
  taskTempSetting,
  dynamicCheckItemSetting,
  evaluate,
  addVersion,
  dccCheck,
  ugc,

  // 活动中心
  activity,

  // system
  system,
};

export default service;
